<div class="ds-tab-content">
  <ng-content></ng-content>
</div>
